import { Create, Edit } from 'react-admin';
import list from './list';
import { FormFields, FormFieldsWithToolbar } from './components';
import { enforceGroupId } from '../../util';

const create = () => (
	<Create record={enforceGroupId()}>
		{FormFields}
	</Create>
);

const edit = () => (
	<Edit record={enforceGroupId()}>
		{FormFieldsWithToolbar}
	</Edit>
);


export const Library = {
	list,
	edit,
	create
};

export default Library;